import React from 'react';
import { useRouter } from './useRouter';
export function useHref(state, params, options) {
  if (params === void 0) {
    params = {};
  }
  if (options === void 0) {
    options = {};
  }
  const router = useRouter();
  const href = React.useMemo(() => {
    return router.href(state, params, options);
  }, [JSON.stringify(state), JSON.stringify(params), JSON.stringify(options)]);
  return href;
}
//# sourceMappingURL=useHref.js.map